const USER_FORM = '/';

export { USER_FORM };
